import { render, staticRenderFns } from "./BillingMetaData.vue?vue&type=template&id=fdb6abf6&"
import script from "./BillingMetaData.vue?vue&type=script&lang=js&"
export * from "./BillingMetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports